export const featureFlags = {
  colorPalette: "color-palette",
  diffSummary: "diff-summary",
  disableWordOnline: "disable-word-online",
  documentSearch: "document-search",
  genestaSections: "genesta-sections",
  halloweenTheme: "halloween-theme",
  legalEntities: "legal-entities-for-if-demo-sept-25",
  pinnedDocuments: "pinned-documents",
  referenceNumber: "reference-number",
  translations: "download-translation",
  workflowTemplates: "workflow-templates",
  wopitest: "wopitest",
} as const;
